module.exports = __webpack_public_path__ + "img/watchlist.b5df8337.jpg";